import script from "./ValidatedSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatedSelect.vue?vue&type=script&setup=true&lang=js"

import "./ValidatedSelect.vue?vue&type=style&index=0&id=83348c3c&lang=less"

const __exports__ = script;

export default __exports__